import { useMemo, useRef, useState } from 'react'
import { useClickAway } from 'react-use'
import { ButtonArea, Container, Dropdown, Option } from './styles'
import { IoIosArrowDown } from 'react-icons/io'
import DefaultIcon from '../../../../assets/dashboard/course-default-icon.png'
import { IDashboardCourse } from '../DashboardContent/types'

interface ICourseDropdownProps {
  courses: IDashboardCourse[]
  value: IDashboardCourse['_id'] | null | undefined
  onChange(course: IDashboardCourse): void

  disabled?: boolean
  loading?: boolean
}

const CourseDropdown = (props: ICourseDropdownProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const [displayDropdown, setDisplayDropdown] = useState(false)

  useClickAway(ref, () => {
    setDisplayDropdown(false)
  })

  const isEmpty = props.courses.length === 0

  const selectedCourse = useMemo(
    () => props.courses.find((course) => course._id === props.value) || null,
    [props.courses, props.value]
  )

  const getIcon = (course: IDashboardCourse | null) => {
    if (course?.icon) return course.icon
    if (course?.publicTenderIcon) return course.publicTenderIcon

    return DefaultIcon
  }

  const toggle = () => {
    if (props.disabled) return
    if (props.loading) return
    if (isEmpty) return

    setDisplayDropdown((state) => !state)
  }

  const renderOptions = () =>
    props.courses.map((course) => (
      <Option
        key={course._id}
        onClick={() => {
          props.onChange(course)
        }}
        isSelected={course._id === props.value}
      >
        <img src={getIcon(course)} className="icon" alt="Logo da Direção Concursos" />
        <p className="course-name" title={course.name}>
          {course.name}
        </p>
      </Option>
    ))

  const renderLabelContent = () => {
    if (props.loading) return 'Carregando cursos...'
    if (isEmpty) return 'Nenhum curso encontrado'

    return selectedCourse?.name || 'Escolha um Curso'
  }

  return (
    <Container onClick={toggle} ref={ref}>
      <ButtonArea disabled={props.disabled || isEmpty} $loading={props.loading}>
        <div className="wrap">
          <img src={getIcon(selectedCourse)} className="icon" alt="Logo da Direção Concursos" />
          <p className="course-name" title={renderLabelContent()}>
            {renderLabelContent()}
          </p>
        </div>

        <IoIosArrowDown size={16} />
      </ButtonArea>

      {displayDropdown && (
        <Dropdown willOverflow={props.courses.length > 3}>{renderOptions()}</Dropdown>
      )}
    </Container>
  )
}

export default CourseDropdown
